import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { delay } from 'rxjs/operators';
import { AAGUID } from '@interticket/core';
import { IMediaSource } from '@core/interfaces/media/media-source.interface';
import { VodStatus } from '@core/enums/media/vod-status.enum';
import { LivestreamVideoStatus } from '@core/enums/media/livestream-video-status.enum';
import { ILivestreamStatus } from '@core/interfaces/media/livestream-status.interface';

@Injectable()
export class MediaSourceMockService implements IMediaSource {

  private readonly statuses: ILivestreamStatus[] = [
    { vodStatus: VodStatus.NONE, liveStreamStatus: LivestreamVideoStatus.OFFLINE },
    { vodStatus: VodStatus.NONE, liveStreamStatus: LivestreamVideoStatus.OFFLINE },
    { vodStatus: VodStatus.READY, liveStreamStatus: LivestreamVideoStatus.OFFLINE },
    { vodStatus: VodStatus.NONE, liveStreamStatus: LivestreamVideoStatus.ONLINE },
  ];

  getStreamableEvents(): Observable<AAGUID[]> {
    return of(['event-id-14', 'event-id-12', 'event-id-1']).pipe(delay(500));
  }

  getLivestreamStatus(eventId: AAGUID): Observable<ILivestreamStatus> {
    const status = this.statuses.shift();
    this.statuses.push(status);
    return of({ ...status }).pipe(delay(500));
  }

}
